import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    attendance:[],
    loading: false,
}

const attendanceSlice = createSlice({
  name: "Attendance",
  initialState: initialState,
  reducers: {
    setAttendance(state, value) {
      state.attendance = value.payload;
    },
    setLoading(state, value) {
      state.loading = value.payload;
    }
  },
});

export const { setAttendance, setLoading} = attendanceSlice.actions;

export default attendanceSlice.reducer;